import { useContext } from 'react';

import FilterDialogContext, { FilterDialogContextValues } from './context';

const useFilterDialog = (): FilterDialogContextValues => useContext(FilterDialogContext);

export default useFilterDialog;
